var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgB2BLogoBw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128.084 128.084",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h484v484H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "prefix__a",
    x: 0,
    y: 0,
    width: 1,
    height: 1,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "hueRotate",
    values: 258,
    result: "colormatrix1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "colormatrix1",
    values: "1 0 0 0 0 1 0 0 0 0 1 0 0 0 0 0 0 0 0 1",
    result: "colormatrix2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "colormatrix1",
    values: "0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0 0 0 0 1",
    result: "colormatrix3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "colormatrix1",
    values: "0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0 0 0 1",
    result: "colormatrix4"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "colormatrix2",
    in2: "colormatrix3",
    mode: "darken",
    result: "blend1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "blend1",
    in2: "colormatrix4",
    mode: "darken",
    result: "blend2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "colormatrix2",
    in2: "colormatrix3",
    mode: "lighten",
    result: "blend3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "blend3",
    in2: "colormatrix4",
    mode: "lighten",
    result: "blend4"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "blend4",
    result: "componentTransfer"
  }, /*#__PURE__*/React.createElement("feFuncR", {
    type: "linear",
    slope: 0
  })), /*#__PURE__*/React.createElement("feBlend", {
    in: "blend2",
    in2: "componentTransfer",
    mode: "lighten",
    result: "blend5"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend5",
    values: "-1 1 0 0 0 -1 1 0 0 0 -1 1 0 0 0 0 0 0 0 1",
    result: "colormatrix5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 1,
    floodColor: "#444440",
    result: "flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix5",
    in2: "flood",
    operator: "arithmetic",
    k1: 1,
    result: "composite1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.01,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "blur",
    result: "blend6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "blend2",
    in2: "blend6",
    operator: "arithmetic",
    k2: 1,
    k3: 1,
    result: "composite2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    operator: "in",
    result: "fbSourceGraphic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "fbSourceGraphicAlpha",
    in: "fbSourceGraphic",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "hueRotate",
    values: 258,
    result: "colormatrix1",
    in: "fbSourceGraphic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "colormatrix1",
    values: "1 0 0 0 0 1 0 0 0 0 1 0 0 0 0 0 0 0 0 1",
    result: "colormatrix2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "colormatrix1",
    values: "0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0 0 0 0 1",
    result: "colormatrix3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "colormatrix1",
    values: "0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0 0 0 1",
    result: "colormatrix4"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "colormatrix3",
    in: "colormatrix2",
    mode: "darken",
    result: "blend1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "colormatrix4",
    in: "blend1",
    mode: "darken",
    result: "blend2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "colormatrix3",
    in: "colormatrix2",
    mode: "lighten",
    result: "blend3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "colormatrix4",
    in: "blend3",
    mode: "lighten",
    result: "blend4"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "blend4",
    result: "componentTransfer"
  }, /*#__PURE__*/React.createElement("feFuncR", {
    type: "linear",
    slope: 0
  })), /*#__PURE__*/React.createElement("feBlend", {
    in2: "componentTransfer",
    in: "blend2",
    mode: "lighten",
    result: "blend5"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend5",
    values: "-1 1 0 0 0 -1 1 0 0 0 -1 1 0 0 0 0 0 0 0 1",
    result: "colormatrix5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 1,
    floodColor: "#444440",
    result: "flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "flood",
    in: "colormatrix5",
    operator: "arithmetic",
    k1: 1,
    result: "composite1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.01,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "blur",
    result: "blend6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blend6",
    in: "blend2",
    operator: "arithmetic",
    k2: 1,
    k3: 1,
    result: "composite2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "fbSourceGraphic",
    operator: "in",
    result: "composite3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 .013 .013)",
    fill: "none",
    filter: "url(#prefix__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.276 261.586c-.604-.604-.879-1.317-.879-2.14v-82.184c0-.933.275-1.701.824-2.25.549-.603 1.263-.878 2.196-.878h36.627c9.829 0 17.243 2.195 22.13 6.474 4.887 4.334 7.303 10.26 7.303 17.721 0 4.389-1.098 8.12-3.24 11.192-2.141 3.072-4.667 5.267-7.523 6.638 3.515 1.591 6.535 4.225 8.951 7.846 2.416 3.621 3.679 7.735 3.679 12.344 0 7.845-2.636 14.154-7.962 18.928-5.327 4.773-12.74 7.187-22.24 7.187h-37.78c-.768 0-1.482-.275-2.086-.878zm36.517-51.242c4.283 0 7.578-1.043 9.939-3.182 2.306-2.085 3.459-4.938 3.459-8.449s-1.153-6.254-3.404-8.229c-2.252-1.921-5.601-2.908-9.994-2.908h-19.604v22.713h19.604zm1.263 38.623c4.393 0 7.797-1.207 10.213-3.621 2.416-2.414 3.679-5.431 3.679-9.162 0-3.676-1.263-6.748-3.734-9.162-2.471-2.414-5.875-3.621-10.158-3.621h-20.867v25.511h20.867zM277.089 261.586c-.604-.604-.878-1.317-.878-2.14v-82.184c0-.933.274-1.701.823-2.25.55-.603 1.263-.878 2.197-.878h36.627c9.829 0 17.242 2.195 22.129 6.474 4.888 4.334 7.304 10.26 7.304 17.721 0 4.389-1.098 8.12-3.24 11.192-2.142 3.072-4.668 5.267-7.523 6.638 3.514 1.591 6.535 4.225 8.951 7.846 2.416 3.621 3.679 7.735 3.679 12.344 0 7.845-2.636 14.154-7.962 18.928-5.327 4.773-12.74 7.187-22.24 7.187h-37.78c-.769 0-1.483-.275-2.087-.878zm36.517-51.242c4.283 0 7.578-1.043 9.939-3.182 2.307-2.085 3.46-4.938 3.46-8.449s-1.153-6.254-3.405-8.229c-2.251-1.921-5.601-2.908-9.994-2.908h-19.604v22.713h19.604zm1.263 38.623c4.393 0 7.798-1.207 10.214-3.621 2.416-2.414 3.679-5.431 3.679-9.162 0-3.676-1.263-6.748-3.734-9.162-2.471-2.414-5.876-3.621-10.159-3.621h-20.867v25.511h20.867z",
    fill: "#67a4c0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.957 261.586c-.604-.603-.878-1.317-.878-2.139v-6.584c0-2.359 1.043-4.334 3.185-5.925 0 0 30.311-28.145 33.551-31.107 3.24-2.963 5.656-5.761 7.249-8.285 1.592-2.523 2.416-4.992 2.416-7.461 0-3.95-1.044-7.077-3.185-9.327-2.087-2.249-5.327-3.401-9.61-3.401-4.228 0-7.523 1.262-9.939 3.73-2.416 2.469-3.899 5.706-4.503 9.656-.274.988-.714 1.756-1.428 2.195-.713.439-1.482.713-2.361.713h-11.367c-.768 0-1.372-.274-1.922-.768-.494-.494-.768-1.152-.768-1.92.164-4.938 1.537-9.601 4.118-13.935 2.581-4.335 6.26-7.846 11.037-10.479 4.778-2.634 10.434-3.95 16.914-3.95 6.754 0 12.465 1.152 17.187 3.456 4.723 2.304 8.237 5.486 10.598 9.546 2.361 4.06 3.515 8.614 3.515 13.771 0 5.651-1.593 10.753-4.723 15.361-3.185 4.609-32.288 32.479-32.288 32.479h35.748c.933 0 1.702.274 2.251.878.604.603.879 1.371.879 2.249v9.108c0 .932-.275 1.645-.879 2.194-.604.549-1.373.823-2.251.823h-60.404c-.824 0-1.538-.274-2.142-.878zM132.999 301.362l2.91-4.06c1.977 2.194 5.217 4.115 9.39 4.115 4.283 0 5.931-2.085 5.931-4.06 0-6.2-17.243-2.359-17.243-13.222 0-4.938 4.283-8.723 10.763-8.723 4.558 0 8.347 1.481 11.037 4.169l-2.91 3.841c-2.361-2.36-5.491-3.402-8.621-3.402-3.02 0-4.997 1.481-4.997 3.676 0 5.541 17.242 2.14 17.242 13.112 0 4.938-3.514 9.162-11.477 9.162-5.436.055-9.39-1.865-12.025-4.608zM189.174 290.718c0-8.833 6.26-15.306 15.156-15.306 8.841 0 15.156 6.473 15.156 15.306 0 8.833-6.315 15.307-15.156 15.307-8.896 0-15.156-6.474-15.156-15.307zm24.986 0c0-6.144-3.844-10.698-9.83-10.698-5.985 0-9.829 4.554-9.829 10.698 0 6.09 3.844 10.699 9.829 10.699 5.931 0 9.83-4.609 9.83-10.699zM253.642 305.531V275.96h20.317v4.554h-15.101v7.626h14.772v4.553h-14.772v12.838zM314.924 305.531v-25.017h-8.951v-4.554h23.118v4.554h-8.95v25.017z",
    fill: "#1b4a5f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.645 71.432c2.417 2.852 2.307 7.132-.384 9.82a7.281 7.281 0 01-5.162 2.14 7.277 7.277 0 01-5.161-2.14l-.659-.658c42.667 42.957 66.169 99.905 66.169 160.474 0 60.897-23.722 118.119-66.828 161.132a7.213 7.213 0 000 10.259 7.28 7.28 0 005.161 2.14 7.283 7.283 0 005.162-2.14C458.795 366.649 484 305.806 484 241.068c0-63.916-24.601-124.045-69.355-169.636z",
    fill: "#67a4c0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.659 484c-64.797 0-125.75-25.237-171.547-70.993C25.26 367.197 0 306.354 0 241.561a7.238 7.238 0 017.248-7.242 7.238 7.238 0 017.249 7.242c0 125.636 102.302 227.9 228.107 227.9a7.239 7.239 0 017.249 7.242 7.17 7.17 0 01-7.194 7.297z",
    fill: "#92cdea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.848 242.439c0-43.835-17.078-84.982-48.104-115.98a7.229 7.229 0 00-10.268 0 7.213 7.213 0 000 10.259c28.28 28.255 43.82 65.781 43.82 105.721s-15.54 77.466-43.82 105.721a7.229 7.229 0 0110.268 0 7.213 7.213 0 010 10.259c31.026-30.997 48.104-72.199 48.104-115.98z",
    fill: "#67a4c0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.843 386.125c38.438 38.404 89.507 59.526 143.816 59.526 54.308 0 105.432-21.122 143.816-59.526 37.45-37.417 58.592-87.122 59.58-139.955.494-27.048-4.283-53.437-14.167-78.454-10.214-25.895-25.535-49.157-45.413-69.018a7.215 7.215 0 010 10.26 7.282 7.282 0 01-5.162 2.139 7.282 7.282 0 01-5.162-2.139c36.627 36.593 56.231 85.202 55.297 136.937-.878 49.103-20.537 95.242-55.297 129.97-35.693 35.661-83.082 55.247-133.547 55.247s-97.854-19.641-133.548-55.247a7.214 7.214 0 010 10.26 7.279 7.279 0 01-5.162 2.139c-1.757 0-3.624-.713-5.051-2.139z",
    fill: "#c7d2d9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.53 98.698c-38.439-38.404-89.508-59.526-143.816-59.526-54.364 0-105.433 21.177-143.871 59.526a7.23 7.23 0 0110.268 0 7.214 7.214 0 010 10.26c35.693-35.661 83.083-55.247 133.548-55.247 50.464 0 97.909 19.64 133.547 55.247a7.282 7.282 0 005.162 2.139 7.282 7.282 0 005.162-2.139c2.8-2.798 2.8-7.407 0-10.26z",
    fill: "#92cdea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.004 388.264a7.28 7.28 0 01-5.161-2.139c-38.44-38.404-59.58-89.427-59.58-143.686s21.14-105.337 59.58-143.686a7.23 7.23 0 0110.268 0 7.214 7.214 0 010 10.26c-35.638 35.606-55.297 83.007-55.297 133.426 0 50.419 19.659 97.82 55.297 133.426a7.214 7.214 0 010 10.26c-1.372 1.426-3.24 2.139-5.107 2.139z",
    fill: "#67a4c0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.714 406.424c-43.875 0-85.06-17.062-116.085-48.06a7.213 7.213 0 010-10.259 7.229 7.229 0 0110.268 0c28.28 28.254 65.84 43.78 105.817 43.78 39.976 0 77.537-15.526 105.817-43.78a7.229 7.229 0 0110.268 0 7.213 7.213 0 010 10.259c-31.025 30.998-72.265 48.06-116.085 48.06zM409.099 83.391a7.277 7.277 0 01-5.161-2.14C360.886 38.24 303.612 14.54 242.714 14.54c-60.898 0-118.227 23.7-161.333 66.713a7.23 7.23 0 01-10.269 0 7.214 7.214 0 010-10.26C116.964 25.238 177.862 0 242.714 0s125.75 25.237 171.547 70.993a7.213 7.213 0 010 10.259 7.281 7.281 0 01-5.162 2.14z",
    fill: "#1b4a5f"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgB2BLogoBw);
export default __webpack_public_path__ + "static/media/b2b_logo_bw.5d350cc15df96e0ced5c4dd69353ae48.svg";
export { ForwardRef as ReactComponent };